import React, { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router";
import { IsAuthorization } from "../../../../app";
import { IDetailKey } from "../../../../utils/common-type";
import { fakeBackstageLog } from "../../../fake-data/backstage-management/system-log";
import { IAction, TemplateTable } from "../../../layout";
import Search from "./search";
import { defaultFilter, IBackstageLog, IFilter, sortableColumns } from "./type";

const BackStageLog = () => {
  const auth = useContext(IsAuthorization);
  const [data] = useState<IBackstageLog[]>(fakeBackstageLog);
  const [filter, setFilter] = useState<IFilter>(defaultFilter());
  const [loading] = useState<boolean>(false);
  const [nextPageAvailable] = useState(false);
  const downloadData = useMemo(() => data, [data]);
  const { t } = useTranslation();
  const T = (name: string) => t(`BackStageLog.${name}`);

  const header: IDetailKey<IBackstageLog>[] = [
    { key: "permission", name: T("permission") },
    { key: "time", name: T("time") },
    { key: "ip", name: T("ip") },
    { key: "username", name: T("username") },
  ];
  const action: IAction<IBackstageLog> = {
    create: false,
    del: false,
    edit: false,
  };

  return !auth.login ? (
    <Redirect to="/login" />
  ) : (
    <>
      <Search data={downloadData} filter={filter} setFilter={setFilter} />
      <TemplateTable<IBackstageLog, IFilter>
        action={action}
        data={data}
        header={header}
        filter={filter}
        setFilter={setFilter}
        reloading={loading}
        sort={sortableColumns}
        toolbar={false}
        isNextPageHaveData={nextPageAvailable}
      />
    </>
  );
};

export default BackStageLog;
